/**
 * Created by Tukta on 15/7/2560.
 */
import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../config/config'
import { connect } from 'react-redux'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import NumberFormat from 'react-number-format'

class DebtorsPay extends Component {

  constructor (props) {
    super(props)
    this.state = {
      lists: [],
      load_data: true,
      danger: false,
      branch: [],
      customer: {},
      debtors_list: [],
      customer_list: [],
      customer_select: false,
      customer_id: '',
      debtors_id: 0,
      debtors: '',
      car_id: '',
      car: '',
      date_pay: new Date(),
      duration_period: [],
      count_period: [],
      amount_pay: 0,
      amount_pay_period: 0,
      user: {}
    }
    this.handleDatePay = this.handleDatePay.bind(this)
  }

  componentWillMount () {
    this.setState({
      user: JSON.parse(this.props.user)
    })
  }

  handleDatePay (date) {
    this.setState({
      date_pay: date
    })
  }

  formatDate (date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
  }

  componentDidMount () {

  }

  handleOnSubmitDebtorsPay (event) {
    event.preventDefault()

    //let that = this
    let debtors_detail = this.props.debtors_detail
    let debtors_detail_id = debtors_detail.debtors_detail_id
    let amount_pay = this.state.amount_pay
    let date_pay = moment(this.state.date_pay).format('YYYY-MM-DD')

    if (amount_pay === 0) {
      alert('กรุณากรอกข้อมูลการชำระเงิน')
      return;
    }

    axios.put(APIURL + '/debtors_detail/pay/'+debtors_detail_id, {
       amount_pay: amount_pay,
       date_pay: date_pay,
       username: this.state.user.user,
    })
      .then(res => {
        if(res.status === 200) {
          this.props.onLoadDebtorsDetailById()
          this.props.onToggle()
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('error' + error)
      })
  }

  render () {

    return (

      <div className="card card-accent-primary">
        <form action="" method="post" onSubmit={this.handleOnSubmitDebtorsPay.bind(this)}>
          <div className="card-header">
            <strong>ข้อมูลการชำระเงิน</strong>
          </div>

          <div className="card-block">
            <div className="row">
              <div className="card-block">

                <div className="row">
                  <div className="form-group col-sm-11 offset-1">
                    <span className="h5">
                      {this.props.debtors_detail.debtors_name}
                      &nbsp;&nbsp;&nbsp;วันที่ต้องชำระ: {this.props.debtors_detail.date_dept}
                      &nbsp;&nbsp;&nbsp;จำนวนเงินที่ต้องชำระ: {this.props.debtors_detail.amount_dept}
                    </span>
                  </div>

                </div>

                <div className="row">

                  <div className="form-group col-sm-6 offset-1">
                    <label htmlFor="amount_of_debt">จำนวนเงินที่ชำระ</label>
                    <input type="text"
                           className="form-control hidden"
                           id="amount_pay"
                           ref="amount_pay"
                           placeholder=""
                           value={this.state.amount_pay}
                           onChange={()=>{}}
                    />
                    <NumberFormat
                      className="form-control"
                      thousandSeparator={true}
                      prefix={'฿'}
                      //placeholder="กรอกค่าโอน"
                      min={0}
                      max={1000000000}
                      step={1000}
                      size={10}
                      allowNegative={false}
                      onValueChange={(values) => {
                        const {value} = values
                        this.setState({amount_pay: value})
                      }}
                    />
                  </div>


                  <div className="form-group col-sm-5">
                    <label htmlFor="date_pay_start">วันชำระ</label>
                    <br/>
                    <DatePicker
                      selected={this.state.date_pay}
                      onChange={this.handleDatePay}
                      dateFormat="YYYY-MM-dd"
                      type="text"
                      className="form-control"
                      id="date_pay"
                      name="date_pay"
                    />
                  </div>


                </div>
              </div>
            </div>

          </div>
          <div className="card-footer text-right">
            <button type="reset"
                    onClick={this.props.onToggle}
                    className="btn btn-sm btn-danger">
              <i className="fa fa-refresh"></i> ยกเลิก
            </button>
            <button type="submit"
                    className="btn btn-sm btn-primary"
            >
              <i className="fa fa-save"></i> บันทึก
            </button>

            <input type="hidden" id="ปปป" name="ปปป"/>

          </div>

        </form>
      </div>
    )
  }
}

/*const styles = {
  bottomLine: {
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
    borderWidth: 0.5,
  }
}*/

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(DebtorsPay)